
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aplicativo",
      function () {
        return require("private-next-pages/aplicativo.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aplicativo"])
      });
    }
  